module.exports = __webpack_public_path__ + "static/media/source_train.1f386f56.png";